export default "__VITE_ASSET__14acf48c__"